import { observable } from "@legendapp/state";
import { ObservablePersistLocalStorage } from "@legendapp/state/persist-plugins/local-storage";
import { synced } from "@legendapp/state/sync";

/** Persisted state for the "Get started" sidebar checklist. */
export const getStartedChecklist$ = observable({
  dismissed: synced<boolean>({
    initial: false,
    persist: {
      name: "get-started.dismissed",
      plugin: ObservablePersistLocalStorage,
    },
  }),
});
